
import axios from "axios";
import rutas from '@/assets/utils/rutas.json';

const getAll = async (params = {}) => {

  const query = `
    query MyQuery(
      $search    : String
      $idPersona : String
    ) {
      allPersona(
        search    : $search
        idPersona : $idPersona
      ) {
        id
        token
        identificacion
        urlIdentificacion
        urlCarnetIssfa
        urlCarnetIsspol
        urlCarnet
        primerNombre
        primerApellido
        segundoApellido
        segundoNombre
        fechaNacimiento
        correo
        telefono
        sexo
        tipoIdentificacion
        esDiscapacitado
        estadoCivil
        nacionalidad{
          id
          descripcion
        }
        nivelEducacion{
          id
          descripcion
        }
        ocupacion{
          id
          descripcion
        }
        nacionalidadEtnia{
          id
          descripcion
        }
        pueblokichwa{
          id
          descripcion
        }
        residencia{
          id
          pais{
            id
            token
            descripcion
          }
          canton{
            id
            descripcion
            idprovincia {
              id
              descripcion
            }
          }
          parroquia
          barrio
          callePrincipal
          calleSecundaria
          referenciaSector
        }
      }
    }
  `;

  const variables = {
    ...params
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allPersona;
    if( !response2 ) return null;
    return response2;

  }catch(error){
    console.error('Error en getAll', error);
    return null;
  }

}

const getByArrayIdsPersons = async (array_ids_persons) => {

  const query = `
    query GetPersonasByArrayIds($arrayIdsPersonas : [ID]!) {
      getPersonasByArrayIds(arrayIdsPersonas: $arrayIdsPersonas) {
        id
        token
        primerApellido
        primerNombre
        identificacion
      }
    }
  `;

  const variables = {
    arrayIdsPersonas : array_ids_persons
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    
    const response2 = response.data.data.getPersonasByArrayIds;
    if( !response2 ) return [];
    return response2;

  }catch(error){
    console.error('Error en getAll', error);
    return null;
  }

}




const searchByQuery = async ( search ) => {

  const params = { search };
  const responseSearch = await getAll(params)

  const data = responseSearch.map(persona => ({
    ...persona,
    value: persona.id,
    text: `${persona.identificacion} ${persona.primerApellido} ${persona.primerNombre}`
  }));

  return data;
 
}



const updateByToken = async (tokenPersona, fields) => {

  if(!tokenPersona) {
    console.error('no hay token');
    return null;
  }
  
  const query = `
    mutation ActualizarPersona(
      $tokenPersona      : String 
      $tipoIdentificacion: String!,
      $identificacion    : String!,
      $apellidos         : String!,
      $nombres           : String!,
      $fechaNacimiento   : String!,
      $nacionalidad      : String,
      $sexo              : String!,
      $telefono          : String!,

      $estadoCivil       : String,
      $email             : String!,
      $nivelEducacion    : String,
      $profesion         : String,
      $puebloKichwa      : String,
      $nacionalidadEtnica: String,

      $esDiscapacitado   : Int,

      $pais              : String,
      $canton            : String,
      $parroquia         : String,
      $barrio            : String,
      $callePrincipal    : String,
      $calleSecundaria   : String,
      $referencia        : String,

      $urlIdentificacion : String,
      $urlCarnet         : String!,
      $urlCarnetIssfa    : String,
      $urlCarnetIsspol   : String,
      
    ) {
      actualizarPersona(
        tokenPersona      : $tokenPersona
        tipoIdent         : $tipoIdentificacion
        identificacion    : $identificacion
        apellidos         : $apellidos
        nombres           : $nombres
        fechaNacimiento   : $fechaNacimiento
        nacionalidad      : $nacionalidad
        sexo              : $sexo
        telefono          : $telefono

        estadoCivil       : $estadoCivil
        email             : $email
        nivelEducacion    : $nivelEducacion
        profesion         : $profesion
        pueKichwa         : $puebloKichwa
        nacioEtni         : $nacionalidadEtnica

        esDiscapacitado   : $esDiscapacitado

        pais              : $pais
        canton            : $canton
        parroquia         : $parroquia
        barrio            : $barrio
        callePrincipal    : $callePrincipal
        calleSecundaria   : $calleSecundaria
        referencia        : $referencia

        urlIdentificacion : $urlIdentificacion
        urlCarnet         : $urlCarnet
        urlCarnetIssfa    : $urlCarnetIssfa
        urlCarnetIsspol   : $urlCarnetIsspol
      ) {
        persona {
          id
          token
        }
      }
    }
  `;


  const variables = {
    tokenPersona      : tokenPersona               || '',
    tipoIdentificacion: fields?.tipoIdentificacion || '',
    identificacion    : fields?.identificacion     || '',
    apellidos         : fields?.apellidos          || '',
    nombres           : fields?.nombres            || '',
    fechaNacimiento   : fields?.fechaNacimiento    || '',
    nacionalidad      : fields?.nacionalidad       || '',
    sexo              : fields?.sexo               || '',
    telefono          : fields?.telefono           || '',

    estadoCivil       : fields?.estadoCivil        || '',
    email             : fields?.email              || '',
    nivelEducacion    : fields?.nivelEducacion     || '',
    profesion         : fields?.profesion          || '',
    puebloKichwa      : fields?.puebloKichwa       || '',
    nacionalidadEtnica: fields?.nacionalidadEtnica || '',

    esDiscapacitado   : fields?.esDiscapacitado,

    urlIdentificacion    : fields?.urlIdentificacion  || '',
    urlCarnet            : fields?.urlCarnet          || '',
    urlCarnetIssfa       : fields?.urlCarnetIssfa     || '',
    urlCarnetIsspol      : fields?.urlCarnetIsspol    || '',
    
    pais              : fields?.pais               || '',
    canton            : fields?.canton             || '',
    parroquia         : fields?.parroquia          || '',
    barrio            : fields?.barrio             || '',
    callePrincipal    : fields?.callePrincipal     || '',
    calleSecundaria   : fields?.calleSecundaria    || '',
    referencia        : fields?.referencia         || '',  
  }

  try{
    
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.actualizarPersona;

    if( !response2 ) return null;
    const data = response2.persona;

    return data;
    
  }catch(error){
    console.error('Error al buscar las personas', error);
    return null;
  }
}



const addPersona = async ( fields ) => {

  const query = `
    mutation crearPersona (
      $tipoIdentificacion: String!,
      $identificacion    : String!,
      $apellidos         : String!,
      $nombres           : String!,
      $fechaNacimiento   : String!,
      $nacionalidad      : String,
      $sexo              : String!,
      $telefono          : String!,

      $estadoCivil       : String,
      $email             : String!,
      $nivelEducacion    : String,
      $profesion         : String,
      $puebloKichwa      : String,
      $nacionalidadEtnica: String,

      $esDiscapacitado   : Int,

      $pais              : String,
      $canton            : String,
      $parroquia         : String,
      $barrio            : String,
      $callePrincipal    : String,
      $calleSecundaria   : String,
      $referencia        : String,

      $urlIdentificacion : String,
      $urlCarnet         : String,
      $urlCarnetIssfa    : String,
      $urlCarnetIsspol   : String,
      $residenciaDefault : Boolean
    ){
      crearPersona(
        tipoIdent         : $tipoIdentificacion
        identificacion    : $identificacion
        apellidos         : $apellidos
        nombres           : $nombres
        fechaNacimiento   : $fechaNacimiento
        nacionalidad      : $nacionalidad
        sexo              : $sexo
        telefono          : $telefono

        estadoCivil       : $estadoCivil
        email             : $email
        nivelEducacion    : $nivelEducacion
        profesion         : $profesion
        pueKichwa         : $puebloKichwa
        nacioEtni         : $nacionalidadEtnica

        esDiscapacitado   : $esDiscapacitado

        pais              : $pais
        canton            : $canton
        parroquia         : $parroquia
        barrio            : $barrio
        callePrincipal    : $callePrincipal
        calleSecundaria   : $calleSecundaria
        referencia        : $referencia

        urlIdentificacion : $urlIdentificacion
        urlCarnet         : $urlCarnet
        urlCarnetIssfa    : $urlCarnetIssfa
        urlCarnetIsspol   : $urlCarnetIsspol

        residenciaDefault : $residenciaDefault
      ){
        persona {
          token,id
        }
        status,
        message
      }
    } 
  `;

  const variables = {
    tipoIdentificacion: fields?.tipoIdentificacion || '',
    identificacion    : fields?.identificacion     || '',
    apellidos         : fields?.apellidos          || '',
    nombres           : fields?.nombres            || '',
    fechaNacimiento   : fields?.fechaNacimiento    || '',
    nacionalidad      : fields?.nacionalidad       || '',
    sexo              : fields?.sexo ?? '0',
    telefono          : fields?.telefono           || '',

    estadoCivil       : fields?.estadoCivil        || '',
    email             : fields?.email              || '',
    nivelEducacion    : fields?.nivelEducacion     || '',
    profesion         : fields?.profesion          || '',
    puebloKichwa      : fields?.puebloKichwa       || '',
    nacionalidadEtnica: fields?.nacionalidadEtnica || '',

    esDiscapacitado   : fields?.esDiscapacitado === null 
      ? null 
      : fields?.esDiscapacitado,

    urlIdentificacion : fields?.urlIdentificacion  || '',
    urlCarnet         : fields?.urlCarnet          || '',
    urlCarnetIssfa    : fields?.urlCarnetIssfa     || '',
    urlCarnetIsspol   : fields?.urlCarnetIsspol    || '',
    
    pais              : fields?.pais               || '',
    canton            : fields?.canton             || '',
    parroquia         : fields?.parroquia          || '',
    barrio            : fields?.barrio             || '',
    callePrincipal    : fields?.callePrincipal     || '',
    calleSecundaria   : fields?.calleSecundaria    || '',
    referencia        : fields?.referencia         || '',
    residenciaDefault : fields?.residenciaDefault  || false
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.crearPersona;

    if (response2.status !== 'success') return null;

    const data = response2.persona;
    return data;

  }catch(error){
    console.error('Error al crear la persona', error);
    return null;
  }
}  


export const personasService = {
  searchByQuery,
  addPersona,
  updateByToken,
  getAll,
  getByArrayIdsPersons
}
